import Home from '../views/Home';
import Scores from '../views/Scores';
import Rewards from '../views/Rewards';
import TopUp from '../views/TopUp';
import AdminTransactions from '../views/admin/Transactions';
import AdminGameTransactions from '../views/admin/Answers';
import AdminRewards from '../views/admin/Rewards';
import AdminGiftpay from '../views/admin/Giftpay';
import AdminQuestions from '../views/admin/Questions';
import LastQuestions from '../views/admin/LastQuestions';
import AdminFeatures from '../views/admin/Features';
import Login from '../components/auth/Login';
import Logout from '../components/auth/Logout';
import Register from '../views/Register';
import Questionview from '../views/admin/Questionview';
import Userslist from '../views/admin/Userslist';
import Usertransactions from '../views/admin/Usertransactions';
import Botuser from '../views/admin/Botuser'

const routes = [
    {
        path: '/balances',
        name: 'balances',
        component: Home,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/gameplay',
        name: 'game-transactions',
        component: AdminGameTransactions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/giftpay',
        name: 'giftpay',
        component: AdminGiftpay,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/questions',
        name: 'questions',
        component: AdminQuestions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/questions-list',
        name: 'questionview',
        component: Questionview,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/users-list',
        name: 'userslist',
        component: Userslist,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/last-200-questions',
        name: 'lasttwohundredquestions',
        component: LastQuestions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/transactions',
        name: 'all-transactions',
        component: AdminTransactions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/rewards',
        name: 'all-rewards',
        component: AdminRewards,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/features',
        name: 'features',
        component: AdminFeatures,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/scores',
        name: 'scores',
        component: Scores,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/rewards',
        name: 'rewards',
        component: Rewards,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/topup',
        name: 'topup',
        component: TopUp,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
        path: '/usertranscationdetails/:userid',
        name: 'user-transactions',
        component: Usertransactions,
        meta: {
            title:'User Transction',
            requiresAuth: true,
        }
    },
    {
        path: '/admin/bots-list',
        name: 'botusers',
        component: Botuser,
        meta: {
            requiresAuth: true,
        }
    },
]


export default routes;
